module.exports = __webpack_public_path__ + "img/07.8f6667da.png";